import { BarChart3, Building2, CalendarDays, CheckCircle2, Users } from "lucide-react";
import PayrollRunSelect from "../../components/common/PayrollRunSelect";

export default function TdsPayrollReportFilters({
  runId,
  runLabel,
  onRunChange,
  departmentId,
  onDepartmentChange,
  departments,
  calMonth,
  onCalMonthChange,
  fy,
  onFyChange,
  fyOptions,
  search,
  onSearchChange,
}) {
  return (
    <section className="tdsr-filters" aria-label="Report filters">
      <div className="tdsr-filters__head">
        <h3 className="tdsr-filters__title">Smart Filters</h3>
        <p className="tdsr-filters__sub">Select payroll month and refine the TDS report</p>
      </div>
      <div className="tdsr-filters__grid">
        <div className="tdsr-filters__field">
          <PayrollRunSelect
            label="Payroll Month"
            value={runId}
            onChange={(id, opt) => onRunChange(id, opt?.label || opt?.period_label || "")}
            allowEmpty
            emptyLabel="Select payroll month"
            hint=""
          />
        </div>
        <label className="tdsr-filters__field">
          <span className="tdsr-filters__label">
            <Building2 size={12} /> Department
          </span>
          <select value={departmentId} onChange={(e) => onDepartmentChange(e.target.value)}>
            <option value="">All Departments</option>
            {departments.map((d) => (
              <option key={d.id} value={d.id}>
                {d.name}
              </option>
            ))}
          </select>
        </label>
        <label className="tdsr-filters__field">
          <span className="tdsr-filters__label">
            <CalendarDays size={12} /> Calendar Month
          </span>
          <input type="month" value={calMonth} onChange={(e) => onCalMonthChange(e.target.value)} />
        </label>
        <label className="tdsr-filters__field">
          <span className="tdsr-filters__label">
            <BarChart3 size={12} /> Financial Year
          </span>
          <select value={fy} onChange={(e) => onFyChange(e.target.value)}>
            {(fyOptions || []).map((y) => (
              <option key={y} value={y}>
                {y}
              </option>
            ))}
          </select>
        </label>
        <label className="tdsr-filters__field tdsr-filters__field--disabled" title="Branch filtering coming soon">
          <span className="tdsr-filters__label">
            <Building2 size={12} /> Branch
          </span>
          <select disabled>
            <option>All Branches</option>
          </select>
        </label>
        <label className="tdsr-filters__field tdsr-filters__field--disabled" title="Employee type filtering coming soon">
          <span className="tdsr-filters__label">
            <Users size={12} /> Employee Type
          </span>
          <select disabled>
            <option>All Types</option>
          </select>
        </label>
        <label className="tdsr-filters__field tdsr-filters__field--disabled" title="Payroll status filtering coming soon">
          <span className="tdsr-filters__label">
            <CheckCircle2 size={12} /> Payroll Status
          </span>
          <select disabled>
            <option>All Statuses</option>
          </select>
        </label>
        <label className="tdsr-filters__field">
          <span className="tdsr-filters__label">Search Employee</span>
          <input
            type="search"
            placeholder="Name or code…"
            value={search}
            onChange={(e) => onSearchChange(e.target.value)}
          />
        </label>
      </div>
      {runLabel && (
        <p className="tdsr-filters__note">
          Selected payroll: <strong>{runLabel}</strong>
        </p>
      )}
    </section>
  );
}
